import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import { BrowserDimensions } from '@panamax/app-state/lib/models/platform.model';
import { TransactionRowDesktopConstants } from '@payments/payments-shared/transaction-row/desktop/transaction-row-desktop.component';
import { CancelPendingPaymentsService } from '@payments/services/cancel-pending-payments/cancel-pending-payments.service';
import { RecentInvoicesCreditsComponent } from '../recent-invoices-credits.component';

@Component({
  selector: 'app-recent-invoices-credits-desktop',
  templateUrl: './recent-invoices-credits-desktop.component.html',
  styleUrls: ['./recent-invoices-credits-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RecentInvoicesCreditsDesktopComponent
  extends RecentInvoicesCreditsComponent
  implements OnInit, OnChanges
{
  @Input() isTouch: boolean;
  @Input() browserDimensions: BrowserDimensions;
  @Input() isLoadingCredits = true;
  @Input() isLoadingInvoices = true;
  constructor(cancelPaymentsService: CancelPendingPaymentsService) {
    super(cancelPaymentsService);
  }

  ngOnInit(): void {
    this.updateColumnSizes();
  }

  ngOnChanges(): void {
    this.updateColumnSizes();
  }

  poNumberClicked() {
    this.showFullPO = !this.showFullPO;
    this.updateColumnSizes();
  }

  updateColumnSizes() {
    this.columnSizes = TransactionRowDesktopConstants.columnSizes(
      false,
      false,
      true,
      this.showFullPO,
      this.showOrderNumber,
    );
  }
}
